<template>
    <div class="gmap-cont">
        <div class="input-group">
            <gmap-autocomplete
                @place_changed="setPlace">
            </gmap-autocomplete>
        </div>
        <gmap-map
            :center="center"
            :zoom="8"
            ref="mapRef"
            style="width:100%;  height: 15rem;"
        ></gmap-map>
    </div>
</template>

<script>
    export default {

        name: "GoogleMap",

        props: ['fetchUrl'],

        data() {
            return {
                center: {lat: 51.5073777, lng: -0.1280179}, // London
                storeMarkers: [],
                storeInfoWindow: null,
                places: [],
                currentPlace: null,
                currentPlaceMarker: null,
                map: null
            };
        },

        mounted() {

            this.$refs.mapRef.$mapPromise.then((map) => {
                this.map = map;
                this.getMarkers();
            });
            this.geolocate();
        },

        methods: {
            // receives a place object via the autocomplete component
            setPlace(place) {
                this.currentPlace = place;

                if (this.currentPlaceMarker !== null) {
                    this.currentPlaceMarker.setMap(null);
                }

                let lat = parseFloat(this.currentPlace.geometry.location.lat()),
                    lng = parseFloat(this.currentPlace.geometry.location.lng());

                this.map.panTo({lat: lat, lng: lng});

                this.currentPlaceMarker = new google.maps.Marker({
                    position: new google.maps.LatLng(lat, lng),
                    icon: 'http://local.gbpopup/img/icons/dot.png',
                    map: this.map
                });

                let infoWindow = new google.maps.InfoWindow({
                    content: '<div class="store-map-content">Your Location</div>'
                });

                infoWindow.open(this.map, this.currentPlaceMarker);

                this.getNearestStores(lat, lng);
            },

            setStores(stores) {
                this.$emit("stores-data", stores);
            },

            getNearestStores: function (lat, lng) {
                axios
                    .get(this.fetchUrl + '/' + lat + '/' + lng)
                    .then(response => {
                        this.setStores(response.data);
                    });
            },

            getMarkers: function () {
                axios
                    .get(this.fetchUrl)
                    .then(response => {
                        let storeMarkers = [];

                        response.data.forEach(element => {

                            let marker = new google.maps.Marker({
                                position: {
                                    lat: parseFloat(element.position.lat),
                                    lng: parseFloat(element.position.lng)
                                },
                                icon: 'http://local.gbpopup/img/icons/marker-pin.png',
                                title: element.name,
                                storeInfo: element,
                                animation: google.maps.Animation.DROP,
                                map: this.map
                            });

                            let ref = this;

                            marker.addListener('click', function () {
                                ref.markerClick(marker);
                            });

                            storeMarkers.push(marker);
                        });

                        this.markers = storeMarkers;

                        this.setStores(response.data);
                    });
            },

            markerClick: function (marker) {
                if (this.storeInfoWindow !== null) {
                    this.storeInfoWindow.close();
                    this.storeInfoWindow = null;
                }

                this.map.panTo(marker.getPosition());

                let contentString = '<div class="store-map-content">' +
                    marker.storeInfo.name + ' (' + marker.storeInfo.company_name + ')'
                '</div>';

                this.storeInfoWindow = new google.maps.InfoWindow({
                    content: contentString
                });

                // To make sure on top of this first 100 markers...
                this.storeInfoWindow.setZIndex(200);

                this.storeInfoWindow.open(this.map, marker);
            },

            geolocate: function () {
                navigator.geolocation.getCurrentPosition(position => {
                    this.map.panTo({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    });
                }, positionError => {
                    console.log(positionError);
                });
            }
        }
    };
</script>
